import React, { useState } from 'react';
import styled, { ThemeProvider } from 'styled-components';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { GlobalStyles } from './GlobalStyles';
import { theme } from './theme';
import Header from './components/Header';
import Hero from './components/Hero';
import Footer from './components/Footer';
import Modal from './components/Modal';
import TermsOfService from './components/TermsOfService';
import PrivacyPolicy from './components/PrivacyPolicy';
import TermsPage from './pages/TermsPage';
import PrivacyPage from './pages/PrivacyPage';

const AppContainer = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
`;

const Main = styled.main`
  flex: 1;
`;

// Home page component
const HomePage: React.FC<{ onTermsClick: () => void; onPrivacyClick: () => void }> = ({ 
  onTermsClick, 
  onPrivacyClick 
}) => (
  <AppContainer>
    <Header />
    <Main>
      <Hero />
    </Main>
    <Footer 
      onTermsClick={onTermsClick}
      onPrivacyClick={onPrivacyClick}
    />
  </AppContainer>
);

function App() {
  const [isTermsOpen, setIsTermsOpen] = useState(false);
  const [isPrivacyOpen, setIsPrivacyOpen] = useState(false);

  const handleTermsClick = () => {
    setIsTermsOpen(true);
  };

  const handleCloseTerms = () => {
    setIsTermsOpen(false);
  };

  const handlePrivacyClick = () => {
    setIsPrivacyOpen(true);
  };

  const handleClosePrivacy = () => {
    setIsPrivacyOpen(false);
  };

  return (
    <ThemeProvider theme={theme}>
      <GlobalStyles />
      <Router>
        <Routes>
          <Route 
            path="/" 
            element={
              <HomePage 
                onTermsClick={handleTermsClick}
                onPrivacyClick={handlePrivacyClick}
              />
            } 
          />
          <Route path="/terms" element={<TermsPage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
        </Routes>
        
        {/* Keep modals for backward compatibility */}
        <Modal
          isOpen={isTermsOpen}
          onClose={handleCloseTerms}
          title="服务条例"
          maxWidth="900px"
        >
          <TermsOfService />
        </Modal>

        <Modal
          isOpen={isPrivacyOpen}
          onClose={handleClosePrivacy}
          title="隐私政策"
          maxWidth="900px"
        >
          <PrivacyPolicy />
        </Modal>
      </Router>
    </ThemeProvider>
  );
}

export default App;
